module.exports = __webpack_public_path__ + "23-o1.jpg?36d7bed875c869beeb636d025debefdb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/23-o1.jpg
// module id = 646
// module chunks = 0